import React from "react";
import { View, StyleSheet, ScrollView, Platform } from "react-native";
import NtMarketingPageContainerHeader from "./NtMarketingPageContainerHeader";
import NtMarketingPageContainerFooter from "./NtMarketingPageConainerFooter";
import { ForceDarkTheme } from "../voxcraft/_shared";

function NtMarketingPageContainer({
  containerStyle,
  children,
  showHeader = true,
  showFooter = true,
}) {
  const body = (
    <>
      {showHeader && <NtMarketingPageContainerHeader />}
      {children}
      {showFooter && <NtMarketingPageContainerFooter />}
    </>
  );

  // On web the <body> is already the scroller (overflow-y:auto in
  // web/index.html), and nesting a ScrollView here would trap `position:
  // sticky` on the nav and hide window-scroll from our scroll-spy. Native
  // platforms still need a ScrollView to scroll the screen.
  return (
    <ForceDarkTheme>
      <View style={[styles.container, containerStyle]}>
        {Platform.OS === "web" ? (
          body
        ) : (
          <ScrollView contentContainerStyle={{ flexGrow: 1 }}>{body}</ScrollView>
        )}
      </View>
    </ForceDarkTheme>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#040506",
    flex: 1,
    // On web the body is the scroller and `flex: 1` only sizes to viewport
    // height — content that overflows then renders past this View and exposes
    // whatever sits behind it. `minHeight: 100%` makes the dark backdrop grow
    // with the content. Ignored on native, where ScrollView already handles it.
    ...Platform.select({ web: { minHeight: "100%" } }),
  },
});

export default NtMarketingPageContainer;
